// removed by extract-text-webpack-plugin
module.exports = {"leftFloatButton":"ContractSupplierEditor-leftFloatButton-34WhB","rightFloatButton":"ContractSupplierEditor-rightFloatButton-3fdVP"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/ContractSupplierEditor.styl
// module id = ./modules/issFrontend/styles/ContractSupplierEditor.styl
// module chunks = 1